import React from 'react';

import { Button } from 'src/common/ui/components';
import { FeatureFlag } from 'src/featureFlags/FeatureFlag';
import useRootStore from 'src/stores/useRootStore';
import { N8N_FORMS_BASE_URL } from 'src/util';

const DspGetHelpButton = ({ patientId }: { patientId: string }) => {
  const {
    auth: { user },
  } = useRootStore();
  const providerId = user?.id || '';
  const handleGetHelp = async () => {
    window.open(
      `${N8N_FORMS_BASE_URL}/dsp-help-request?PatientId=${patientId}&ProviderId=${providerId}`,
      '_blank',
      'width=600,height=500,location=no,toolbar=no,menubar=no,scrollbars=yes,status=no',
    );
  };
  return (
    <FeatureFlag name="dspHelpButton">
      {N8N_FORMS_BASE_URL && <Button onClick={handleGetHelp}>Get Help</Button>}
    </FeatureFlag>
  );
};

export default DspGetHelpButton;
